/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboardingorganizertitle2Inputs */

const en_onboardingorganizertitle2 = /** @type {(inputs: Onboardingorganizertitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizer or club`)
};

const de_onboardingorganizertitle2 = /** @type {(inputs: Onboardingorganizertitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstalter oder Verein`)
};

/**
* | output |
* | --- |
* | "Organizer or club" |
*
* @param {Onboardingorganizertitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const onboardingorganizertitle2 = /** @type {((inputs?: Onboardingorganizertitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboardingorganizertitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboardingorganizertitle2(inputs)
	return de_onboardingorganizertitle2(inputs)
});
export { onboardingorganizertitle2 as "onboardingOrganizerTitle" }